import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthTokenService } from '../services/authtoken.service';
import { TokenService } from '../services/token.service';

/**
 * Guard de entrada del portal. Impide que se cargue la SPA del portal (y sus rutas
 * admin) sin una sesion. Es un gate de UX / defense-in-depth: la frontera de auth real
 * es el backend (JwtAuthFilter -> 401/403 -> auth.interceptor.performLogout).
 *
 * NO exige sesion de BD (isActive): un usuario nuevo de CIAM tiene token pero aun no
 * tiene registro, y debe poder entrar a /portal/admin/usuarios/nuevo. Por eso el gate
 * es "hay token" o "llega un token valido por ?q=", no "sesion activa".
 */
export const portalGuard: CanActivateFn = (route) => {
  const authToken = inject(AuthTokenService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  // 1) Sesion valida = token en sessionStorage.
  if (authToken.hasToken()) {
    return true;
  }

  // 2) Bootstrap del login: el token entra por ?q= (aterrizaje de CIAM / login interno),
  //    todavia NO guardado en sessionStorage al correr el guard. Se acepta SOLO si ?q=
  //    decodifica a un JWT bien formado (bloquea ?q=basura, que seria un bypass del guard).
  //    MainComponent / new-user-ciam lo persisten en sessionStorage al montar.
  const q = route.queryParamMap.get('q');
  if (q) {
    try {
      if (tokenService.decodeToken(atob(decodeURIComponent(q)))) {
        return true;
      }
    } catch {
      /* ?q= invalido -> cae al redirect */
    }
  }

  // 3) Sin sesion -> /login (reusa LoginRedirectComponent, que redirige a CIAM).
  return router.createUrlTree(['/login']);
};
